import { isEqual } from 'lodash'

import { proxy } from '@/utils'

import render from './render'

export default {
  name: 'RulesGeneratorButtons',

  mixins: [ proxy({ type: 'array' }) ],

  data() {
    return {
      defaultButton: {
        text: undefined,
        action: undefined
      }
    }
  },

  methods: {
    _outputFilter(data) {
      return data.filter(item => {
        return item.text && item.action
      })
    },

    transmitValue() {
      const proxy = this._outputFilter(this.proxy)
      if (!isEqual(proxy, this.value)) {
        this.$emit('input', proxy)
      }
    }
  },

  render
}
